import React from 'react';
import ReactDOM from 'react-dom';
import { ServicesOverview } from "./components";

export const initClusterServicesOverview = (target) => {
  if (target) {
    const servicesData = JSON.parse(target.dataset.servicesData);
    const notificationsData = JSON.parse(target.dataset.notificationsData);
    ReactDOM.render(
      <ServicesOverview
        servicesData={servicesData}
        notificationsData={notificationsData}
      />,
      target
    );
  }
}
